import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import { HelmetProvider } from 'react-helmet-async';
import MyNavbar from "./Components/Navbar";
import Hero from "./Components/Hero";
import Footer from "./Components/Footer";
import ScrollToTop from "./Components/ScrollToTop";
import CookieModal from "./Components/CookieModal";
import About from "./Components/About";
import Services from "./Components/Services";
import Contact from "./Components/Contact";
import Policy from "./Components/Policy";
import Terms from "./Components/Terms";
import Cookies from "./Components/Cookies";

function App() {
  return (
    <HelmetProvider>
    <Router>
      <ScrollToTop />
      <MyNavbar />
      <CookieModal />
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/cookies" element={<Cookies />} />
      </Routes>
      <Footer />
    </Router>
    </HelmetProvider>
  );
}

export default App;
